'use strict';

var isArray = require('./is-array'),
    isArrayLike = require('./is-array-like'),
    getKeys = require('./get-keys');

/**
 * Bind @param thisArg to the callback
 *
 * @param {Function} callback
 * @param {*} thisArg
 * @returns {Function}
 */
function bindArg(callback, thisArg) {
    return function (val, key) {
        callback.call(thisArg, val, key);
    };
}

/**
 * Parform a callback-based array iteration
 *
 * @param {array} array
 * @param {Function} iteratee
 * @returns {array}
 */
function iterateArray(array, iteratee) {
    var index = -1,
        length = array.length;

    while (++index < length) {
        if (iteratee(array[index], index) === false) {
            break;
        }
    }

    return array;
}

/**
 * Parform a callback-based object iteration
 *
 * @param {object} object
 * @param {Function} iteratee
 * @returns {object}
 */
function iterateObject(object, iteratee) {
    var keys = getKeys(object),
        index = -1,
        length = keys.length;

    while (++index < length) {
        if (iteratee(object[keys[index]], keys[index]) === false) {
            break;
        }
    }

    return object;
}

/**
 * Perform a blazing fast collection iteration
 *
 * @param {object|array} collection
 * @param {Function} iteratee
 * @param {*} [thisArg]
 * @returns {object|array}
 */
function foreach(collection, iteratee, thisArg) {
    if (typeof thisArg !== 'undefined') {
        iteratee = bindArg(iteratee, thisArg);
    }

    //Test if the collection is Array or Array-like
    if (isArray(collection) || isArrayLike(collection)) {
        return iterateArray(collection, iteratee);
    } else if (collection) {
        return iterateObject(collection, iteratee);
    }
}

module.exports = foreach;
